/* ════ CURRENCY ════════════════════════════════════════════ */
// Format a number as GBP. Whole pounds show no decimals; otherwise 2 dp.
export function gbp(n) {
  const v = Number(n) || 0;
  return '£' + v.toLocaleString('en-GB', {
    minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
